import type { Funcionario, FuncionarioSetor } from "@shared/schema";

/**
 * Perfil EXIBIDO na UI. São TRÊS para o usuário, mas só DOIS regimes no banco:
 *
 *   Diarista   → tipo_remuneracao = 'DIARISTA'
 *   Mensalista → tipo_remuneracao = 'MENSALISTA', sem vínculo de setor
 *   Encarregado→ tipo_remuneracao = 'MENSALISTA' COM ≥1 vínculo ativo em
 *                funcionario_setor
 *
 * "Encarregado" é DERIVADO do vínculo — nunca um terceiro valor gravado em lugar
 * nenhum. Promover um mensalista a encarregado é vincular um setor, não migrar
 * regime.
 */
export type PerfilFuncionario = "DIARISTA" | "MENSALISTA" | "ENCARREGADO";

export function perfilDoFuncionario(
  funcionario: Pick<Funcionario, "id"> & { tipoRemuneracao?: string | null },
  vinculosAtivos: Pick<FuncionarioSetor, "funcionarioId" | "fim">[] = [],
): PerfilFuncionario {
  if ((funcionario.tipoRemuneracao ?? "DIARISTA") !== "MENSALISTA") return "DIARISTA";
  const temSetor = vinculosAtivos.some(v => v.funcionarioId === funcionario.id && !v.fim);
  return temSetor ? "ENCARREGADO" : "MENSALISTA";
}

export const PERFIL_META: Record<PerfilFuncionario, {
  label: string;
  dot: string;
  badge: string;
  descricao: string;
}> = {
  DIARISTA: {
    label: "Diarista",
    dot: "🟢",
    badge: "bg-green-100 text-green-800 border-green-300",
    descricao: "Paga por dia trabalhado. Nada muda no fluxo atual.",
  },
  MENSALISTA: {
    label: "Mensalista",
    dot: "🔵",
    badge: "bg-blue-100 text-blue-800 border-blue-300",
    descricao: "Salário fixo. As tarefas viram registro sem valor — não entram na quinzena.",
  },
  ENCARREGADO: {
    label: "Encarregado",
    dot: "🟣",
    badge: "bg-purple-100 text-purple-800 border-purple-300",
    descricao: "Mensalista responsável por setores. Mesmos campos, mais os setores e o teto da variável.",
  },
};
